import React from "react"
import styled from "styled-components"

import Typography from "@material-ui/core/Typography"

import * as theme from "../../../theme"

const Downloads = ({ downloads }) => {
  return (
    <Container>
      {!!downloads &&
        downloads.map((download, index) => {
          return (
            <ItemWrapper key={index}>
              <Item
                href={
                  !!download.file.url ? download.file.url.publicURL : undefined
                }
                target="_blank"
              >
                <Typography variant="h6">{download.file.title}</Typography>
              </Item>
            </ItemWrapper>
          )
        })}
    </Container>
  )
}

export default Downloads

const Container = styled.div`
  display: block;
  padding-bottom: 30px;
`

const ItemWrapper = styled.div`
  display: block;
`
const Item = styled.a`
  text-decoration: none;
  display: inline-block;
  &:hover {
    &:after {
      transform: scaleX(1);
    }
  }
  &:after {
    transform-origin: 0 100%;
    display: block;
    content: "";
    border-bottom: solid 2px ${theme.color.green};
    transform: scaleX(0);
    transition: transform 150ms ease-in-out;
  }
`
